export default __webpack_public_path__ + "static/media/background_color_vn.6ff394a2.jpg";